// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voteRadioActive,.voteRadioActive:focus,.voteRadioActive:hover{background:#1b5297!important;color:#fff}.el-dropdown-menu__item,.el-select-dropdown__item{font-size:12px}", ""]);
// Exports
module.exports = exports;
